import React, { useEffect, useState } from 'react'
import module from './index.module.css'
import { Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { finishEkyc, startEKyc } from '../../../../../util/eKyc';

const FinishEKyc = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(true);
    const navigate = useNavigate();

    const setErrorMessages = (e) => {
        if (e.message === "failed_to_ekyc") {
            setError("顔認証に失敗しました");
        } else if (e.message === "no_data") {
            setError("データの取得に失敗しました");
        } else {
            setError(true);
        }
    }

    const updateAuth = async () => {
        try {
            setIsLoaded(true);
            setError(false);
            await finishEkyc();
            navigate("/mypage/reward/setting");
            // setIsLoaded(false);
        } catch (e) {
            navigate("/mypage/reward/setting");
            // setErrorMessages(e);
            // setIsLoaded(false);
        }
    }

    useEffect(() => {
        updateAuth();
    }, [])

    const handleStart = async () => {
        try {
            setIsLoaded(true);
            setError(false);
            await startEKyc();
            setIsLoaded(false);
        } catch (e) {
            setErrorMessages(e);
            setIsLoaded(false);
        }
    }

    return (
        <div>
            <div className={module.top}>
                <h1 className={module.title}>待機中</h1>
            </div>
            <div className={module.contents}>
                {isLoaded && (<CircularProgress color="success" />)}
                {error && (<div>
                    <p>エラーが発生しました</p>
                    <p>再度実行ください</p>
                    <p>
                        <Button
                            variant="outlined"
                            sx={{ padding: "2px 8px", marginLeft: "8px", marginTop: "16px" }}
                            onClick={handleStart}
                        >
                            再度顔認証を開始する
                        </Button>
                    </p>
                </div>)}
            </div>
        </div>
    )
}

export default FinishEKyc